// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3uGd9","choiceBoxes":"toolbarselects_choiceBoxes__1L7-l","simpleField":"toolbarselects_simpleField__8W7eG"};